import getCurrentSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import getTableConversationRelation from './getTableConversationRelation';
import isItemView from 'owa-mail-store/lib/utils/isItemView';

/**
 * @param rowId mail list row id
 * @returns the itemId itself for item view and the first itemId for conversation view.
 */
export const getFirstItemIdInMailListRow = (rowId: string): string => {
    const currentTableView = getCurrentSelectedTableView();
    return isItemView(currentTableView)
        ? rowId
        : getTableConversationRelation(rowId, currentTableView.id)?.itemIds?.[0];
};
